import AdminList from "@/components/Admin/AdminList/AdminList.vue";
import ClientEdit from "@/components/Admin/ClientEdit/ClientEdit.vue";
import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
import copy from "copy-to-clipboard";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
import { debounce } from "lodash";

const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "ClientList",
  components: {
    AdminList,
    ClientEdit
  },

  data: () => ({
    headers: [
      { text: "Id", value: "client_id" },
      { text: "Name", value: "name" },
      { text: "Aktionen", value: "actionChange", sortable: false },
      { text: "Key holen", value: "actionGetKey", sortable: false },
      { text: "Key erneuern", value: "actionRefreshKey", sortable: false }
    ],
    defaultFilter: { searchText: "", itemsPerPage: 25 },
    dialogContent: "",
    filter: {},
    showDialog: false,
    showEditDialog: false,
    editedKey: {}
  }),
  async mounted() {
    this.filter = this.defaultFilter;
    this.filter.itemsPerPage = this.defaultFilter.itemsPerPage;
    try {
      await this.applyFilter(this.filter);
    } catch (err) {
      await this.$store.dispatch("createError", err.message);
    }
  },
  computed: {
    clients() {
      return this.$store.state.oAuthClients.map(client => ({
        ...client,
        active: !client.deleted
      }));
    }
  },
  methods: {
    async getKey(clientId) {
      const headers = getTokenHeader();
      let response;
      try {
        response = await axios.get(
          `${env.auth_api_client_url}clients/getclientkey/${clientId}`,
          { headers }
        );
      } catch (err) {
        await this.$store.dispatch("createError", err.message);
      }
      const publicKey = response?.data?.data?.public_key;
      if (publicKey) {
        this.dialogContent = publicKey;
        this.showDialog = true;
      } else await this.$store.dispatch("createError", "No publicKey found");
    },
    copyToClipboard(text) {
      copy(text);
      this.closeDialog();
    },
    closeDialog() {
      this.showDialog = false;
      this.dialogContent = "";
    },
    async refreshKey(id) {
      const isConfirmed = await this.$confirm(
        "Wollen sie wirklich den Key erneuern? Sie müssen danach ihre Dienste aktualisieren",
        confirmWarningConfig
      );
      if (isConfirmed) {
        const headers = getTokenHeader();
        try {
          const response = await axios.put(
            `${env.auth_api_client_url}clients/refreshkeys/${id}`,
            {},
            { headers }
          );
          if (response.status === 200)
            await this.$store.dispatch(
              "createSuccess",
              "Key wurde erfolgreich erneuert"
            );
        } catch (err) {
          await this.$store.dispatch("createError", err.message);
        }
      }
    },
    editKey(key) {
      this.showEditDialog = true;
      this.editedKey = key || {};
    },
    closeEditDialog() {
      this.editedKey = {};
      this.showEditDialog = false;
    },
    async saveEditedKey(editedKey) {
      const headers = getTokenHeader();
      let response, successText;
      if (editedKey.client_id) {
        try {
          successText = "Erfolgreich gespeichert";
          response = await axios.put(
            `${env.auth_api_client_url}clients/update/`,
            editedKey,
            {
              headers
            }
          );
        } catch (err) {
          await this.$store.dispatch("createError", err.message);
        }
      } else {
        successText = "Erfolgreich angelegt";
        try {
          response = await axios.post(
            `${env.auth_api_client_url}clients/add/`,
            editedKey,
            {
              headers
            }
          );
        } catch (err) {
          await this.$store.dispatch("createError", err.message);
        }
      }
      if (response?.status === 200 || response?.status === 201) {
        await this.$store.dispatch("createSuccess", successText);
        this.closeEditDialog();
      }
    },
    async applyFilter(filter) {
      if (!filter) filter = this.filter;
      if (filter.limit) delete filter.limit;
      await this.$store.dispatch("getOAuthClients", filter);
    },
    applySearchText: debounce(async function() {
      if (this.filter.searchText.length >= 3 || !this.filter.searchText.length)
        await this.applyFilter(this.filter);
    }, 500)
  }
};
